import { SpyneTrait, SpyneAppProperties, ChannelFetchUtil } from 'spyne';
import { LocalStorageTraits} from 'traits/local-storage-traits';
import { createAuth0Client } from '@auth0/auth0-spa-js';
import { isNotNil, isNotEmpty, both} from 'ramda';

export class AuthTraits extends SpyneTrait {
  constructor(context) {
    super(context, 'auth$');
  }


  static auth$GetRedirectLocation(){
    const port = LocalStorageTraits.localStorage$GetCallbackPort();
    return port ? `http://localhost:${port}` : '/'
  }

  static auth$GetRedirectToRegistryBool(){
    const port = LocalStorageTraits.localStorage$GetCallbackPort();

   //console.log("PORT BOOL CHECK ",{port}, both(isNotNil, isNotEmpty)(port))
    return both(isNotNil, isNotEmpty)(port);
  }

  static auth$ResetCallbackPort(){
    LocalStorageTraits.localStorage$ClearCallbackPort();
  }

  static async auth$OnInit(e) {

    let token, role;
    let isAuthenticatedForBasicInfo, userInfo;
    const { domain, clientId, authStateObj } = e.payload;
    const {authState, authIntent, successValidated} = authStateObj;


    const redirectUri = `${window.location.origin}#/callback`;
    const audience = 'https://users-spynejs/';
    const apiUrl = SpyneAppProperties.getProp('apiDynamoDb');

    const redirectToRegistryBool = this.auth$GetRedirectToRegistryBool();
    const redirectLocation = this.auth$GetRedirectLocation();

    const objForAuth0 = {
      domain,
      clientId,
      authorizationParams: { audience, redirect_uri: redirectUri }

    }


    if (!this.props.auth0) {
      this.props.auth0 = await createAuth0Client({
        domain,
        clientId,
        authorizationParams: { audience, redirect_uri: redirectUri }
      });
    }

    const auth0 = this.props.auth0;

    if (location.search.includes('state=') && location.search.includes('code=')) {



      try {

        await auth0.handleRedirectCallback();
        this.auth$ResetCallbackPort();
      } catch (e) {
        if (e.message.includes("Issuer (iss) claim mismatch")) {

          console.warn("Clearing stale Auth0 tokens…");
          Object.keys(localStorage).forEach(key => {
            if (key.includes('auth0') || key.includes('@@auth0spajs')) {
              localStorage.removeItem(key);
            }
          });
          sessionStorage.clear();

          window.location.href = "/";
          return;
        }

        // rethrow if it's not this known issue
        throw e;
      }








      window.history.replaceState({}, document.title, '/');
    }

    let isAuthenticated = false;
    let userProfile, userRecord;

    if (successValidated === true){
      localStorage.removeItem('postAuthIntent');
      //localStorage.removeItem('spyneUser');
      userProfile = await auth0.getUser();
      //console.log("user in successValidated", userProfile);

/*

      try {
       // await auth0.getTokenSilently();
        userProfile = await auth0.getUser();

      } catch (err) {
        console.warn("Silent token refresh failed. Using fallback redirect.", err);

        // fallback — invisible prompt=none redirect
       await auth0.loginWithRedirect({
          authorizationParams: {
            prompt: "none",
            redirect_uri: window.location.href
          }
        });
      }
*/





/*      try {
        // This forces token renewal, fetching a fresh token from Auth0
        await auth0.getTokenSilently({
          detailedResponse: false,
          cacheMode: "off" // <— important: bypass cached token
        });

      } catch (err) {
        console.error("Silent refresh failed:", err);
      }*/
    }

    try {
      isAuthenticated = await auth0.isAuthenticated({ audience });
      userProfile = await auth0.getUser();
      //console.log("user profiile in generic getUser try ",userProfile);
    } catch (err) {
      if (err.error !== 'login_required') throw err;
    }

    this.props.isAuthenticated = isAuthenticated;
    this.props.userProfile = userProfile;
    this.props.origin = window.location.origin;
    this.props.apiUrl = apiUrl;

    if (isAuthenticated) {
      isAuthenticatedForBasicInfo = isAuthenticated;
      //const roles = userProfile["https://spynejs.com/roles"]
      const roles = userProfile["https://spynejs.com/roles"];         // ["premium_user"]
      const plan = userProfile["https://spynejs.com/plan"];
      const auth0Token = await auth0.getTokenSilently();
      role = ['pro_beta', 'pro', 'premium'].includes(plan) ? 'premium' : plan;
      const termsAccepted = userProfile["https://spynejs.com/termsAccepted"];
      const tosAccepted = String(termsAccepted) === 'true';

      userInfo = {
        name: userProfile.name,
        email: userProfile.email,
        sub: userProfile.sub,
        picture: userProfile.picture,
        tosAccepted,
        role,
        iat: Math.floor(Date.now() / 1000)
      };

      LocalStorageTraits.localStorage$SetUser(userInfo);

      //console.log("USER IN AUTHENTICATED IS ",{isAuthenticated,userProfile,userInfo,roles, role, plan, auth0Token, auth0});


      let spyneToken;

      try {
        userRecord = await this.auth$CheckOrCreateUser(auth0Token, userProfile);

        //console.log("USSER IS ",{userProfile,roles, userRecord, auth0});

      } catch (err) {
        console.error('[AuthTraits] Check/Create user failed:', err);
      }

      // 3️⃣ If this login originated from a local CMS → redirect to registry
      const urlParams = new URLSearchParams(window.location.search);
      const callbackPort = 8078;// urlParams.get('callbackPort');
      userProfile.role = role;
      //console.log("SEND REQUEST BEFORE ", {role,isAuthenticatedForBasicInfo, userProfile})
      this.auth$SendAuthenticationRequestEvent({ isAuthenticated, role, isAuthenticatedForBasicInfo, userRecord, userProfile });

      if (redirectToRegistryBool) {

        try {
          role =  userProfile?.role || "free";
          const email = userProfile?.email || "ubu@spynejs.com";
          const sub =   userProfile?.sub || "auth0|console-test";
          const picture =   userProfile?.picture || "//assetscontainer.com/assets/imgs/default.png";

          if (window.location.origin.includes('localhost')){
             spyneToken = process.env.SPYNE_DEV_TOKEN;
          } else {
            const res = await fetch('https://spynejs.com/sign-token', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email, sub, role, picture })
            });

            const { token: signedToken } = await res.json();
            spyneToken = signedToken;
          }

        } catch (err) {
          console.error('[AuthTraits] Spyne re-tokenization failed:', err);
        }


        if (redirectToRegistryBool){
          await this.auth$OnRedirectToRegistry(redirectLocation, spyneToken);
        }

        return auth0Token;
      }
      return auth0Token;
    } else {

      userProfile = LocalStorageTraits.localStorage$GetUser();
      isAuthenticatedForBasicInfo = userProfile !== null;

      //console.log("USER FROM LOCAL STORAGE ",{userProfile, isAuthenticatedForBasicInfo})
    }




    // Broadcast to CHANNEL_AUTH
    //console.log("auth request send ",{role, isAuthenticatedForBasicInfo, userProfile})
    this.auth$SendAuthenticationRequestEvent({ isAuthenticated, role, userRecord, isAuthenticatedForBasicInfo, userProfile });


  }


  static auth$SendAuthenticationRequestEvent(payload = {isAuthenticated, userRecord, userProfile}){
    this.sendInfoToChannel('CHANNEL_AUTH', payload, 'CHANNEL_AUTH_AUTHENTICATION_REQUEST_EVENT');

  }

  static async auth$CheckOrCreateUser(token, userProfile) {
    const { sub: userId, email, name = 'Unknown' } = userProfile;
    const apiUrl = this.props.apiUrl;
    const reqBody = { requestType: 'ensureUserExists', userId, email, name };


   //console.log("GET AWS USER INFO ",{apiUrl, reqBody, token})
    try {
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(reqBody)
      });
      if (!res.ok) throw new Error(`API ${res.status}`);
      const record = await res.json();
      this.props.userRecord = record;
      return record;
    } catch (err) {
      console.error('[auth$CheckOrCreateUser]', err);
      return null;
    }
  }

  static async auth$OnRedirectToRegistry(appRedirectUrl, spyneToken) {
    if (!appRedirectUrl || !spyneToken) return;

    const registryUrl = `http://localhost:52931/auth/callback?token=${spyneToken}`;

    //console.log("token is ",spyneToken);
   // const appRedirectUrl = `http://localhost:${callbackPort}`;
    //console.log('registry occurring ', {appRedirectUrl, registryUrl, spyneToken})
    try {
      // 1️⃣ Notify local Spyne Registry (update ~/.spyne-dev-registry.json)
      //const res = await fetch(registryUrl);

      const res = await fetch("http://localhost:52931/auth/callback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: spyneToken }),
      });

      if (!res.ok) {
        console.warn(`[AuthTraits] Registry callback failed (${res.status})`);
      } else {
        const html = await res.text();
       //console.log("✅ Auth complete:", html);
      }
      // 2️⃣ Redirect back to user’s local app

      LocalStorageTraits.localStorage$ClearCallbackPort();

     window.location.href = appRedirectUrl;
    } catch (err) {
      console.error('[AuthTraits] Error redirecting to local registry:', err);
    }
  }



  static async auth$GetToken() {
    try {
      const token = await this.props.auth0.getTokenSilently();
      return { isLoggedIn: true, token };
    } catch {
      return { isLoggedIn: false, token: null };
    }
  }

  static auth$onUIEvent(e) {
    const { eventType } = e.payload;
    const auth0 = this.props.auth0;

    //console.log("ON UI EVENT ",{eventType})

    if (eventType === 'login') {
      auth0.loginWithRedirect();
    } else if (eventType === 'logout') {
      LocalStorageTraits.localStorage$RemoveUserCache();
      auth0.logout({ logoutParams: { returnTo: this.props.origin } });

    } else if (eventType === "toggleProfile") {
     //console.log("TOGGLE PROFILE ", e);
      //const currentState = e?.srcElement?.el?.parentElement.classList.contains("active");
      const currentState = document.querySelector('#auth-view .auth-view-state-item').classList.contains('active');
      const toggleState = !currentState;
      this.sendInfoToChannel("CHANNEL_AUTH", { toggleState }, "CHANNEL_AUTH_TOGGLE_REQUEST_EVENT");
      // this.sendChannelPayload("CHANNEL_AUTH_TOGGLE_PROFILE_EVENT", {toggleState});
    }
  }
}
